module.exports = __webpack_public_path__ + "static/media/queplanta-text-dark.eb975ba1.svg";